import { render, staticRenderFns } from "./line-pay-confirm.vue?vue&type=template&id=3b22d815&scoped=true"
import script from "./line-pay-confirm.vue?vue&type=script&lang=js"
export * from "./line-pay-confirm.vue?vue&type=script&lang=js"
import style0 from "./line-pay-confirm.vue?vue&type=style&index=0&id=3b22d815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b22d815",
  null
  
)

export default component.exports